import { render, staticRenderFns } from "./email-tab.vue?vue&type=template&id=38f76148"
import script from "./email-tab.vue?vue&type=script&lang=js"
export * from "./email-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports